import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  ButtonGroup, Dropdown, DropdownButton, Button,
} from 'react-bootstrap5';

import {
  useNavigate,
} from 'react-router-dom';

import routes from 'app/routes';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import confirmAlert from 'components/new_ui/Alerts/confirm';

import Actions from 'components/Members/Schedule/Actions';
import Card from './Card';

export default function SessionToScheduleItem({ step, refresh }) {
  const [scheduleWaiting, setScheduleWaiting] = useState(false);

  const navigate = useNavigate();

  const onCompleteClick = () => {
    confirmAlert(
      {
        title: 'Complete Step',
        text: 'Are you sure you want to complete this step?',
        confirmButtonText: 'Complete',
      },
      () => {
        Actions.completeStep(step.id, (data) => {
          if (refresh) {
            refresh();
          }
        });
      },
    );
  };

  const onScheduleClick = () => {
    setScheduleWaiting(true);
    Actions.possibilitySchedule(step.attributes.program.id, (data) => {
      setScheduleWaiting(false);
      if (data.possibility) {
        navigate(routes.members.steps.schedule(step.id), {
          state: { step, source: 'sessions' },
        });
      } else {
        navigate(routes.members.steps.buyOrSkip(step.id), {
          state: { isPossibleSkip: data.isPossibleSkip, reason: data.reason },
        });
      }
    });
  };

  return (
    <Card record={step}>
      <>
        <ButtonGroup>
          <DropdownButton
            as={ButtonGroup}
            variant="outline-primary"
            title="More"
          >
            {step.attributes.is_completable && <Dropdown.Item
              eventKey={`session-card-${step.id}-completed-page`}
              onClick={onCompleteClick}
              target="_blank"
              rel="noreferrer"
            >
              Completed
            </Dropdown.Item>}

            <Dropdown.Item
              eventKey={`session-card-${step.id}-program-page`}
              href={routes.members.programs.show(step.attributes.program.id)}
              target="_blank"
              rel="noreferrer"
            >
              Program
            </Dropdown.Item>

            <Dropdown.Item
              eventKey={`session-card-${step.id}-chat-page`}
              href={routes.members.chats.messages(step.attributes.program.chat_id)}
              target="_blank"
              rel="noreferrer"
            >
              Chat
            </Dropdown.Item>
          </DropdownButton>
        </ButtonGroup>

        <Button disabled={scheduleWaiting} className="ms-3" onClick={onScheduleClick}>
          {scheduleWaiting && <LoadingPlaceholder placement="inline" text=" " />}
          Schedule
        </Button>
      </>
    </Card>
  );
}

SessionToScheduleItem.propTypes = {
  step: PropTypes.object.isRequired,
};
